import { Link } from "react-router-dom";
import { InfoContainer, Text } from "$components";
import useJStyles from "$hooks/useJStyles";
import DockyardIcon from "../../DockyardIcon";
import EditButton from "../components/EditButton";
import { useStyles } from "../styles";
import { DockyardDetailsLogic } from "../types";

type DockyardGeneralInfoProps = Pick<
  DockyardDetailsLogic,
  | "dockyard"
  | "idChantier"
  | "canEdit"
  | "isFullyDisabled"
  | "filteredInterveningCompanies"
  | "handleClickChantier"
>;

export default function DockyardGeneralInfo({
  dockyard,
  idChantier,
  canEdit,
  isFullyDisabled,
  filteredInterveningCompanies,
  handleClickChantier,
}: DockyardGeneralInfoProps) {
  const classes = useStyles();
  const { jclasses } = useJStyles();

  return (
    <InfoContainer
      className={[classes.informationHeader, classes.InfoHeight].join(" ")}
      leftHeader={
        <div className={classes.infoHeader}>
          <DockyardIcon />
          <Text type="h3">Informations chantier</Text>
        </div>
      }
      rightHeader={
        <EditButton
          onClick={handleClickChantier}
          canEdit={canEdit}
          isFullyDisabled={isFullyDisabled}
        />
      }
    >
      <div className="about">
        <div className="left">
          <table>
            <tbody>
              <tr>
                <td className="label">Code projet</td>
                <td className="data">
                  {(dockyard?.project as any)?.code || ""}
                </td>
              </tr>
              <tr>
                <td className="label">Nom projet</td>
                <td className="data">
                  <Link
                    to={`/chantiers/${idChantier}/projets/${
                      (dockyard?.project as any)?._id
                    }`}
                    className={jclasses.ghostLink}
                  >
                    {(dockyard?.project as any)?.name || ""}
                  </Link>
                </td>
              </tr>
              <tr>
                <td className="label">Code chantier</td>
                <td className="data">{dockyard?.code || ""}</td>
              </tr>
              <tr>
                <td className="label">Nom chantier</td>
                <td className="data">{dockyard?.name || ""}</td>
              </tr>
              {dockyard?.codeAnalytics && (
                <tr>
                  <td className="label">Code analytique</td>
                  <td className="data">{dockyard?.codeAnalytics || "N/A"}</td>
                </tr>
              )}
              <tr>
                <td className="label">Adresse</td>
                <td className="data">
                  {dockyard &&
                    (!dockyard.address &&
                    !dockyard.address2 &&
                    !dockyard.postalCode &&
                    !dockyard.country ? (
                      <div className="div">Non renseignée</div>
                    ) : (
                      <>
                        <div className="div">{dockyard?.address || ""}</div>
                        {dockyard?.address2 && (
                          <div className="div">{dockyard?.address2 || ""}</div>
                        )}
                        <div className="div">{`${
                          dockyard?.postalCode || ""
                        } ${(dockyard?.city || "").toUpperCase()}`}</div>
                        <div className="div">
                          {(dockyard?.country || "").toUpperCase()}
                        </div>
                      </>
                    ))}
                </td>
              </tr>
              <tr>
                <td className="label">Entreprise(s) intervenante(s)</td>
                {dockyard && (
                  <td className="data">
                    {filteredInterveningCompanies?.map((c, idx) => (
                      <Link
                        to={`/entreprise/${c?._id}`}
                        className={jclasses.ghostLink}
                        key={c._id}
                      >
                        {c.name}
                        {idx !== filteredInterveningCompanies.length - 1 &&
                          " | "}
                      </Link>
                    ))}
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </InfoContainer>
  );
}
